import { MediaLibraryFileModel } from './sales-funnel';

export class SystemUserBase {
    id: number;
    name: string;
    email: string;
    createdAt: number;
    avatar?: Partial<MediaLibraryFileModel>[]
    avatar_id?: number[];
    source?: 'automatic' | 'manual';
}

export class CustomerItem extends SystemUserBase {

}


